import { HttpService } from "@/core";
import axios from "axios";
let cancleAxios: any = null;
export const post = () => {
  const api = (url, data: any = {}) =>
    HttpService.axios({
      method: "POST",
      url,
      data,
    });
  return HttpService.useRequest<any>(api);
};
export const getList = () => {
  const api = (url, params: any = {}, cancelToken, method = "GET") => {
    let obj = {
      method: method,
      url,
      cancelToken,
    };
    if (method == "post" || method == "POST") {
      obj["data"] = params;
    } else {
      obj["params"] = params;
    }
    return HttpService.axios(obj);
  };

  return HttpService.usePagination<any>(api);
};
